import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const PartnerApply = lazy(() => import("@/pages/PartnerApply"));

export const Route = createFileRoute("/partner-apply")({
  component: PartnerApply,
});
